// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyOutlinedSvg from "@fishx/icons-svg/es/asn/TrophyOutlined";
import FishxIcon from '../components/FishxIcon';

var TrophyOutlined = function TrophyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyOutlinedSvg
  }));
};

TrophyOutlined.displayName = 'TrophyOutlined';
export default React.forwardRef(TrophyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrophyOutlined.js
// module id = 4287
// module chunks = 0